import { StyledInfoAlert } from "./alert.styled";
import { Box, palette, Stack, Typography } from "@mzc-pdc/ui";
import { IconInfoCircle } from "@mzc-cloudplex/icons";

const InfoAlert = ({ content, iconSize = 16 }) => {
    if (!content) return null;
    return (
        <StyledInfoAlert
            severity={"info"}
            color={"info"}
            variant={"outlined"}
            icon={<IconInfoCircle size={iconSize} htmlColor={palette.info[700]} />}
            size={iconSize}
        >
            <Stack container direction={"column"} spacing={1}>
                {content.title && (
                    <Typography variant={"body1_500"} color={palette.greySecondary[800]}>
                        {content.title}
                    </Typography>
                )}
                <Typography variant={"body1_400"} color={palette.greySecondary[800]} gap={1}>
                    {content.data?.map((item) => (
                        <>
                            {item.subTitle && <Box component={"span"}>{item.subTitle}</Box>}
                            {item.section}
                        </>
                    ))}
                </Typography>
            </Stack>
        </StyledInfoAlert>
    );
};

export default InfoAlert;
